
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55 65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.47 0l21.648 21.647v35.718a7.576 7.576 0 01-7.577 7.576H7.576A7.576 7.576 0 010 57.365V7.576A7.576 7.576 0 017.576 0h24.895z","fill":"#E94848"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.237 29.812a2.597 2.597 0 00-2.586 2.585c0 1.764.98 3.954 2.012 6.012-.806 2.525-1.722 5.231-2.893 7.514-.424.167-.84.326-1.244.48-1.881.718-3.516 1.343-4.573 2.195a.773.773 0 00-.057.065 2.598 2.598 0 001.842 4.42c.692 0 1.36-.259 1.843-.752a.78.78 0 00.048-.04c.946-1.13 2.061-3.178 3.055-5.05 2.29-.901 4.69-1.818 7.005-2.368 1.69 1.362 4.136 2.262 6.149 2.262a2.597 2.597 0 002.585-2.585 2.597 2.597 0 00-2.585-2.586c-1.614 0-3.96.576-5.753 1.18-1.454-1.365-2.79-3.07-3.75-4.88.104-.32.21-.64.317-.958.594-1.784 1.17-3.517 1.17-4.909a2.597 2.597 0 00-2.585-2.585zm0 1.551c.58 0 1.034.454 1.034 1.034 0 .776-.416 2.205-.897 3.742-.643-1.495-1.171-2.929-1.171-3.742 0-.58.454-1.034 1.034-1.034zm3.127 12.258a20.754 20.754 0 01-2.683-3.41c-.54 1.646-1.112 3.318-1.826 4.929 1.478-.563 2.976-1.1 4.509-1.52zm7.474-.105c.58 0 1.034.453 1.034 1.034 0 .58-.454 1.034-1.034 1.034-1.165 0-2.821-.526-4.145-1.26 1.52-.43 3.177-.808 4.145-.808zM13.45 51.264c.505-.61 1.228-1.82 1.955-3.119-1.5.6-2.82 1.163-3.426 1.633a1.11 1.11 0 00-.275.719c0 .58.454 1.034 1.034 1.034a.984.984 0 00.712-.267z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.118 21.647H40.43c-4.185 0-7.96-3.775-7.96-7.96V0l21.648 21.647z","fill":"#fff","fill-opacity":".4"}})])
          )
        }
      }
    